/* istanbul ignore file */
export const getIsolatedStepStyles = (_, { palette }) => ({
  cardLayout: {
    height: '100%',
    width: '100%',
    backgroundImage: 'radial-gradient(at 2.7% 92.9%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 100.2% 77.6%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 1.3% 13.0%, #f0f3f5 0px, transparent 50%),radial-gradient(at 55.5% 13.8%, #fcf9f5 0px, transparent 50%),radial-gradient(at 55.7% 72.1%, #ffffff 0px, transparent 50%),radial-gradient(at 96.0% 12.2%, hsl(200, 35%, 93%) 0px, transparent 50%)',
    '& .react-block-ui-none, .react-block-ui': {
      height: '100%',
      width: '100%',
    },
  },
  mainContainer: {
    overflow: 'auto',
    height: '100%',
    width: '100%',
    paddingTop: 100,
    paddingBottom: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cardContainer: {
    background: palette.white,
    width: 700,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 32,
    justifyContent: 'space-between',
  },
  'cardContainer-l': {
    width: 618,
  },
  'cardContainer-m': {
    width: 424,
  },
  'cardContainer-s': {
    width: 312,
    padding: 16,
  },
  cardContentContainer: {
    minHeight: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footerContainer: {
    marginTop: 32,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  'footerContainer-s': {
    '& .ms-Stack': {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  tailContainer: {
    marginTop: 32,
    width: '100%',
  },
});

export const getSDKIsolatedStepStyles = () => ({
  cardLayout: {
    '&.sdk-campaign-creation-isolated-step': {
      backgroundImage: 'none',
    },
  },
});
